import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {EmailApiService} from '../api/email-api.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.css'
})
export class ContactUsComponent {
    contactForm: FormGroup;
    successMessage = '';
    errorMessage = '';
    submitting = false;

    constructor(
        private fb: FormBuilder,
        private emailApi: EmailApiService,
        private toastr: ToastrService
    ) {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            phone: [''],
            email: ['', [Validators.required, Validators.email]],
            message: ['', Validators.required]
        });
    }

    get name() {
        return this.contactForm.get('name');
    }

    get phone() {
        return this.contactForm.get('phone');
    }

    get email() {
        return this.contactForm.get('email');
    }

    get message() {
        return this.contactForm.get('message');
    }

    sendMessage(): void {
        if (this.contactForm.invalid) {
            this.contactForm.markAllAsTouched();
            return;
        }
        this.submitting = true;
        const contactData = this.contactForm.value;

        this.emailApi.sendContactEmail(contactData).subscribe({
            next: (res) => {
                this.successMessage = 'Your message has been sent successfully!';
                this.errorMessage = '';
                this.toastr.success('Message sent successfully!');
                this.contactForm.reset();
            },
            error: (err) => {
                this.submitting = false;
                console.error('Error sending message', err);
                this.successMessage = '';
                this.errorMessage = 'Failed to send your message. Please try again later.';
                this.toastr.error('Message sending failed');
            }
        });
    }
}